import { render, staticRenderFns } from "./BeritaEdit.vue?vue&type=template&id=9ec8cb7c"
import script from "./BeritaEdit.vue?vue&type=script&lang=js"
export * from "./BeritaEdit.vue?vue&type=script&lang=js"
import style0 from "./BeritaEdit.vue?vue&type=style&index=0&id=9ec8cb7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports